var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('issue-filter',{on:{"change":_vm.onChange}}),_c('br'),_c('issue-response-average',{attrs:{"filter-form":_vm.filterForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }